import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles,
    border: 0,
    borderRadius: 0,
  },
  headerTitleBox: {
    width: '100%',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
    '& h5': {
      fontWeight: '600',
      fontSize: '1.25rem',
      color: theme.palette.blue_300.main
    },
    '& .MuiTypography-gutterBottom': {
      marginBottom: 0
    }
  },
  headerTutorial: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& span': {
      fontWeight: '600',
      fontSize: '1rem'
    },
    '& button': {
      color: theme.palette.blue_100.main,
      '& span': {
        display: 'flex',
        gap: '4px'
      }
    },
    '& button:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent'
    }
  },
  headerDescription: {
    '& span': {
      color: theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main
    }
  },
}))
